import { render, staticRenderFns } from "./addAbsent.vue?vue&type=template&id=12c284c1&"
import script from "./addAbsent.vue?vue&type=script&lang=js&"
export * from "./addAbsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports